module.exports = __webpack_public_path__ + "static/media/qrim.8d453986.png";